import {
  addProductCardListeners,
  addProductShowListeners,
  cartCountListener,
  cartItemListeners,
  removeItem,
} from "./_new/cartControl";
import {sendRequest} from "./_new/utils";
import Viewer from "viewerjs";
import Inputmask from "inputmask";
import Swal from "sweetalert2";

window.$ = window.jQuery = require("jquery");
require("ion-rangeslider/js/ion.rangeSlider.min");
require("select2/dist/js/select2.min");
require("jquery-ui-dist/jquery-ui.min");
require("slick-carousel/slick/slick.min.js");

searchEvent();
closeDropdownEventAndSearchItem();
openHeaderMenuOnMobile();
addProductCardListeners();
jsSliderListener();
filterBtnSwitchListener();
feedbackEvent();
productFeedbackEvent();
addPhoneMask();
categoriesStyleSwitch();
createGallery();
addProductShowListeners();
removeItem();
cartItemListeners();
changeSelectsToSelect2();
cartCountListener();
homeModalListener();
feedbackModalListener();
errorsAlertOnAuthPages();
partners();

function addListenerToCarousel() {
  let carousel = document.querySelector(".carousel");

  let intervalCarousel = window.setInterval(() => {
      let currentButton = document.querySelector(".js-btn");
      if (currentButton) {
        let nextButton = document.querySelector(
          `.carousel-btn[data-item="item_${(parseInt(currentButton.dataset.item.match(/\d+/)[0])) + 1}"]`
        );
        if (!nextButton) {
          nextButton = document.querySelector(`.carousel-btn[data-item="item_0"]`);
        }

        nextButton.dispatchEvent(new Event("click"));
      }
    }, 5000);

  if (carousel) {
    let buttons = carousel.querySelectorAll(".carousel-btn");
    let noveltiesWrapper = carousel.querySelector(".carousel-wrapper");

    let interval = intervalCarousel;

    buttons.forEach((el) => {
      el.addEventListener("click", () => {
        let oldItem = noveltiesWrapper.querySelector(".carousel-item-show");
        let newItem = noveltiesWrapper.querySelector(`#${el.dataset.item}`);

        $(oldItem).hide("fade", {queue: false}, 800, () => {
          oldItem.classList.remove("carousel-item-show");
          let oldBtn = document.querySelector(".js-btn");
          if (oldBtn) {
            oldBtn.classList.remove("js-btn");
          }

          el.classList.add("js-btn");

          $(newItem).show("fade", {queue: false}, 800, () => {
            newItem.classList.add("carousel-item-show");
          });
        });

        // window.clearInterval(interval)
        interval = intervalCarousel
      });
    });
  }
}

addListenerToCarousel();

function changeSelectsToSelect2() {
  $(document).ready(() => {
    $(".select2").select2();
  });
}

function searchEvent() {
  let searchButton = document.querySelector(".header-inner-search-switch");
  let form = document.querySelector(".header-inner-search-wrapper");

  if (searchButton && form) {
    searchButton.addEventListener("click", () => {
      form.classList.toggle("header-inner-search-wrapper-hidden");
    });

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      let searchQuery = form.querySelector(".header-inner-search-wrapper-input")
        .value;
      if (searchQuery) {
        let searchData = await sendRequest(form.action, { q: searchQuery });
        await document
          .querySelectorAll(".search-item")
          .forEach((el) => el.remove());
        let template = document.getElementById("searchItem");
        let parent = document.getElementById("searchItemWrapper");

        await fun();

        async function fun() {
          if (searchData.notFound) {
            let item = template.content.cloneNode(true);
            item.querySelector(".title").value = searchData.notFound;
            parent.appendChild(item);
          } else {
            searchData.data.forEach((el) => {
              let item = template.content.cloneNode(true);
              item.querySelector(".title").value = el.title;
              item.querySelector(".sub").value = el.category_title;
              item.querySelector("a").href = new URL(
                `/product/${el.slug}/`,
                window.location.href
              );
              parent.appendChild(item);
            });
          }
        }
      }
    });
  }
}

function closeDropdownEventAndSearchItem() {
  document.body.addEventListener("click", (e) => {
    document.querySelectorAll(".search-item").forEach((el) => el.remove());
    document.querySelectorAll("details[open]").forEach((el) => {
      if (
        e.target !== document.querySelector("i.fas.fa-phone.fa-lg") &&
        e.target !==
          document.querySelector("summary.header-inner-phones-dropdown-title")
      ) {
        el.open = false;
      }
    });
  });
}

function openHeaderMenuOnMobile() {
  let menu = document.querySelector(".header-menu-items");
  let openBtn = document.querySelector('#mobileOpenBtn');
  let closeBtn = document.querySelector('#mobileCloseBtn')

  if (menu && openBtn && closeBtn && openBtn) {
    openBtn.addEventListener("click", () => {
      closeBtn.classList.add('mobile-only')
      menu.classList.toggle("header-menu-items-hidden");
      document.body.style.overflow = 'hidden';
    });
    closeBtn.addEventListener('click', () => {
      menu.classList.add('header-menu-items-hidden');
      closeBtn.classList.remove('mobile-only')
      document.body.style.overflow = 'auto';
    })
  }
}

function jsSliderListener() {
  let slider = document.querySelector(".js-range-slider");
  // let minSpan = document.querySelector("[name='priceMin']");
  // let maxSpan = document.querySelector("[name='priceMax']");

  if (slider) {
    $(slider).ionRangeSlider({
      type: "double",
      skin: "round",
      min: slider.min,
      max: slider.max,
      step: 0.01,
      postfix: " ₴",
      // onChange: (data) => {
      //   minSpan.innerHTML = data.from;
      //   maxSpan.innerHTML = data.to;
      // },
    });
  }
}

function filterBtnSwitchListener() {
  let filterButton = document.querySelector(".js-switch-filters");
  if (filterButton) {
    filterButton.addEventListener("click", () => {
      filterButton.parentElement.classList.toggle("categories-filters-show");
    });
  }
}

function partners() {
  $('.partners.autoplay').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
      ]
  });
}

function feedbackEvent() {
  let feedbackForm = document.querySelector("form.feedback");
  if (feedbackForm) {
    let phone = feedbackForm.querySelector('input[name="phone"]'),
      full_name = feedbackForm.querySelector('input[name="full_name"]'),
      product = feedbackForm.querySelector('input[name="product"]'),
      message = feedbackForm.querySelector('input[name="message"]'),
      data = product ? product.value : null || message ? message.value : null;

    feedbackForm.addEventListener("submit", (e) => e.preventDefault());

    let button = feedbackForm.querySelector('button[type="button"]');
    button.addEventListener("click", async () => {
      if (phone.value && full_name.value) {
        await sendRequest(feedbackForm.action, {
          full_name: full_name.value,
          phone: phone.value,
          message: data ? data : null,
        });
      }
    });
  }
}

function productFeedbackEvent() {
  let productFeedbackForm = document.querySelector("form.product-feedback");
  if (productFeedbackForm) {
    let phone = productFeedbackForm.querySelector('input[name="phone"]'),
      fullName = productFeedbackForm.querySelector('input[name="full_name"]'),
      product = productFeedbackForm.querySelector('input[name="product"]'),
      message = productFeedbackForm.querySelector('input[name="message"]'),
      data = product ? product.value : null || message ? message.value : null;

    productFeedbackForm.addEventListener("submit", (e) => e.preventDefault());

    let button = productFeedbackForm.querySelector('button[type="button"]');
    button.addEventListener("click", async () => {
      if (phone.value && fullName.value) {
        await sendRequest(productFeedbackForm.action, {
          full_name: fullName.value,
          phone: phone.value,
          message: data ? data : null,
        });
      }
    });
  }
}

function addPhoneMask() {
  document.querySelectorAll(".js-phone-mask").forEach((el) => {
    new Inputmask("+38(999) 999 9999", {"placeholder": ""}).mask(el);
  });
}

function categoriesStyleSwitch() {
  function switcher(style, old) {
    document.querySelectorAll(".product-card").forEach((el) => {
      el.classList.remove(old);
      el.classList.add(style);
    });
  }

  document
    .querySelectorAll("button.categories-items-control-view-item")
    .forEach((el) => {
      el.addEventListener("click", () => {
        switcher(el.dataset.style, el.dataset.old);

        localStorage.setItem('style', el.dataset.style);
        localStorage.setItem('old_style', el.dataset.old)

        document
          .querySelectorAll("button.categories-items-control-view-item")
          .forEach((el) => {
            el.classList.remove("categories-items-control-view-item-active");
          });

          el.classList.add("categories-items-control-view-item-active");
      });

      if (localStorage.getItem('style') === null) {
        localStorage.setItem('style', el.dataset.style);
        localStorage.setItem('old_style', el.dataset.old)
      }

      document
        .querySelectorAll("button.categories-items-control-view-item")
        .forEach((el) => {
          if (el.dataset.style === localStorage.getItem('style')) {
            el.classList.add("categories-items-control-view-item-active");
          } else {
            el.classList.remove("categories-items-control-view-item-active");
          }
        })

      switcher(localStorage.getItem('style'), localStorage.getItem('old_style'))
    });


}

function createGallery() {
  let images = document.getElementById("images");
  if (images) {
    // eslint-disable-next-line no-unused-vars
    const gallery = new Viewer(images, {
      url(image) {
        return image.src.replace("thumbs/", "");
      },
    });
  }
}

async function homeModalListener() {
  let modalBtn = document.getElementById('modalBtn')
  modalBtn?.addEventListener('click', async () => {
    await Swal.fire({
      title: modalBtn.dataset.title,
      html: modalBtn.nextElementSibling.innerHTML,
      width: "80%"
    })
  })
}

async function feedbackModalListener() {
  let feedbackModal = document.getElementById('feedbackModal');
    // auth = $('#app').attr('auth') === 'true';

  feedbackModal?.addEventListener('click', async () => {
    await Swal.fire({
      title: feedbackModal.dataset.title,
      html: feedbackModal.nextElementSibling.innerHTML,
      showCancelButton: true,
      // showLoaderOnConfirm: auth,
      showLoaderOnConfirm: true,
      onRender: (e) => {addPhoneMask()},
      confirmButtonText: feedbackModal.dataset.confirm,
      // confirmButtonText: auth ? feedbackModal.dataset.confirm : feedbackModal.dataset.auth,
      cancelButtonText: feedbackModal.dataset.cancel,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: () => {
        // if (!auth) {
        //   window.location.href = '/login';
        // } else {
          let token = document.head.querySelector('meta[name="csrf-token"]')?.content,
            data = new FormData(),
            lang = $('html').attr('lang');

          data.phone = $('#swal2-content').find('form.all-page-feedback input.js-phone-mask').val();
          data.full_name = $('#swal2-content').find('form.all-page-feedback input[name=full_name]').val();

          if (data.full_name.length < 3) {
            Swal.showValidationMessage(
              data.full_name.length <= 0 ? 'Ім\'я обов\'язково!' : 'Ім\'я повинно бути довшим!'
            )
            return;
          }

          if (data.phone.length === 17 && data.full_name.length > 3) {
            return fetch($(feedbackModal).next().find('form.all-page-feedback').attr('action'), {
              method: 'POST',
              headers: {
                "X-CSRF-TOKEN": token,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data)
            })
            .then(response => {
              if (!response.ok) {
                throw new Error(response.statusText)
              }
              return response.json();
            })
            .catch(error => {
              Swal.showValidationMessage(
                `Запрос не выполнен: ${error}`
              )
            })
          } else {
          //   let lang = $('html').attr('lang');

            Swal.showValidationMessage(
              data.phone.length <= 0 ? 'Номер телефону обов\'язково!' : 'Номер телефону не вірно зазначений!'
            )
          }
        // }
      },
    }).then((result) => {
      if (result.isConfirmed/* && auth*/) {
        Swal.fire({
          title: result.value.message,
          text: result.value.body
        })
      }
    })
  })
}

async function errorsAlertOnAuthPages() {
  let errors = document.querySelector('.hidden-errors')
  if (errors) {
    await Swal.fire({
      icon: "error",
      title: errors.innerHTML,
      position: "top-end",
      toast: true,
      timer: 5000,
      showConfirmButton: false,
    });
  }
}
